export default __webpack_public_path__ + "static/media/icon_google_play.72085a10.png";